import { useState } from "react";
import { useIntl } from "react-intl";
import IntlMessages from "../../../../../util/IntlMessages";
import "../SingleCase.less";
import "../../../../Planner/CaseLabelPopover/CaseLabelPopover.less";
import { Icon_ChevronDown, Icon_ChevronUp } from "../../../../BP2Components/Icons/icons";

const MAX_VISIBLE_TAGS = 5;

interface TagsSectionProps {
   tagsToDisplay: string[];
   privateTagsToDisplay: string[];
}

export const TagsSection = ({ tagsToDisplay, privateTagsToDisplay }: TagsSectionProps) => {
   const intl = useIntl();
   const [showAllTags, setShowAllTags] = useState<boolean>(false);
   const [showAllPrivateTags, setShowAllPrivateTags] = useState<boolean>(false);

   const renderTags = (tags: string[], showAll: boolean, toggle: (value) => void) => {
      const visibleTags = showAll ? tags : tags.slice(0, MAX_VISIBLE_TAGS);
      return (
         <>
            <ul className="p1 single-case__info-wrapper__content">
               {tags.length > 0 ? (
                  visibleTags.map((tag) => (
                     <li key={tag} className="case-label-tags">
                        {tag}
                     </li>
                  ))
               ) : (
                  <li className="case-label-tags--lack">
                     {intl.formatMessage({ id: "planner.noTags" })}
                  </li>
               )}
            </ul>
            {tags.length > MAX_VISIBLE_TAGS && (
               <button type="button" onClick={toggle} className="single-case__show-more">
                  {showAll ? (
                     <span>
                        {intl.formatMessage({ id: "planner.showLess" })}{" "}
                        <Icon_ChevronUp width={10} height={6} />
                     </span>
                  ) : (
                     <span>
                        {intl.formatMessage({ id: "planner.showMore" })}{" "}
                        <Icon_ChevronDown width={10} height={6} />
                     </span>
                  )}
               </button>
            )}
         </>
      );
   };

   return (
      <div className="single-case__tags-section">
         <div>
            <span className="single-case__info-wrapper__label">
               <IntlMessages id="planner.tags" />
            </span>
            {renderTags(tagsToDisplay, showAllTags, () => setShowAllTags((prev) => !prev))}
         </div>
         <div>
            <span className="single-case__info-wrapper__label">
               <IntlMessages id="planner.privateTags" />
            </span>
            {renderTags(privateTagsToDisplay, showAllPrivateTags, () =>
               setShowAllPrivateTags((prev) => !prev),
            )}
         </div>
      </div>
   );
};
